<template>
  <div @click="viewOrderDetail" class="progress">
    <div class="disable">不可预约</div>
    <div v-if="!isDisable" class="progressContainer">

      <div class="all" :style="outerWidth"><span>{{all}}</span></div>
      <div class="ordered" :style="orderedWidth"><span>{{ordered}}</span></div>
      <div class="dealed" :style="dealedWidth"><span>{{dealed}}</span></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "progressBar",
    props: {
      progressBarData: {
        type: Object
      }
    },
    data() {
      return {
        isDisable: false,
        all: null,
        ordered: null,
        dealed: null
      }
    },
    computed: {
      outerWidth() {
        return 'width:100%'
      },
      orderedWidth() {
        let width = Math.max(Math.min((this.ordered / this.all) * 100, 100),5)
        return `width:${width}%`
        //return `left:calc( 8% - 6px );width:${width}%`
      },
      dealedWidthValue() {
        return Math.max(Math.min((this.dealed / this.all) * 100, 100),5)
      },
      dealedWidth() {
        let width = this.dealedWidthValue
        return `width:${width}%`
      },
    },
    methods: {
      _initData() {
        if (this.progressBarData.freeCount === undefined || this.progressBarData.holdCount === undefined) {
          this.isDisable = true
          return
        }
        this.all = this.progressBarData.holdCount + this.progressBarData.freeCount
        if (!this.all) {
          this.isDisable = true
          return
        }
        this.ordered = this.progressBarData.holdCount
        this.dealed = this.progressBarData.dealwithCount | 0
      },
      viewOrderDetail() {
        this.$emit('viewOrderDetail', this.progressBarData)
      }
    },
    mounted() {
      this._initData()

    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .progress
    border 1px solid #666
    height 15px
    overflow hidden
    border-radius 8px
    line-height 12px
    position relative

    .disable
      height 100%
      width 100%
      font-size 12px
      color #666666
      text-shadow none
      text-align center
      background-color #eeeeee
      z-index 9

    .progressContainer
      cursor pointer
      height 100%
      width 100%
      position absolute
      left 0
      top 0
      text-align right
      line-height 12px
      font-size 12px
      color #ffffff
      text-shadow 1px 1px 1px #000

      & > div
        display inline-block
        padding-right 5px
        border-top-right-radius 8px
        border-bottom-right-radius 8px
        text-align right
        position absolute
        left 0
        top 0
        bottom 0

        & > span
          position relative

      // color #666
      // text-shadow none
      // right -5px
      // top -15px

      .all
        height 100%
        width 100%
        background-color #d2e9ff
        color #666666
        text-shadow none
        z-index 1

      .ordered
        height 100%
        width 50%
        background-color #004a94
        z-index 2

      .dealed
        height 100%
        width 20%
        background-color #16a61e
        z-index 3


</style>


// WEBPACK FOOTER //
// src/components/order/progress.vue